export default "__VITE_ASSET__BpXa1AVv__"